<script>
    import { createEventDispatcher } from 'svelte';

    import Select from './Select.svelte';
    import TextArea from './TextArea.svelte';

    import { ReturnToServices } from 'src/store/return-to-services';

    export let value;
    export let output = "id"
    export let placeholder = 'Select template';

    const dispatch = createEventDispatcher();

    const handleSelect = ({ detail: detailValue }) => {
        const service = $ReturnToServices.find(el => el[output] === detailValue);
        value = service && service.description || null;
        dispatch('change', value);
    };

    const handleChange = () => dispatch('change', value);

    const handleClear = () => {
        value = undefined;
        dispatch('change', value);
        dispatch('clear');
    }

    $: items = $ReturnToServices.map(({ [output]: value, title: label }) => ({ value, label }));
    $: selectedTemplate = value && { value, label: value } || null;
</script>

<div class="return-to-service-select">
    <label class="label" for="return-to-service-template">Template</label>
    <Select
        {items}
        {selectedTemplate}
        {placeholder}
        on:change={handleSelect}
        on:clear={handleClear}
    />

    <div style="margin-top: 15px">
        <label class="label required" for="return-to-service-notes">Notes</label>
        <TextArea
            id="return-to-service-notes"
            bind:value
            on:change={handleChange}
        />
    </div>
</div>
